/// <reference path="../../apps/typings/customTds.d.ts" />

 
export namespace Auth {

	export function getBearerToken(callback?: (token: string) => void): JQueryXHR {
		return T.Utils.Auth.getBearerToken(callback);
	}
}
